export const loadScript = (src, id) => {
    return new Promise((resolve, reject) => {
        if (document.getElementById(id)) return resolve(); // already loaded
    
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
    });
};
  
export const loadCSS = (href, id) => {
    if (document.getElementById(id)) return;
  
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.id = id;
    document.head.appendChild(link);
};